<template>
  <div class="disciplinaryMeasure">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">My Team Training Needs</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Training Needs</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto"></div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="sortedTrainingNeeds"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <a class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></a>
                      <a>{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</a>
                    </h2>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditNeed(item)"
                          v-if="!item.curriculumUrl"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setApproveNeed(item)"
                          v-if="!item.curriculumUrl"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteNeed(item)"
                          v-if="!item.curriculumUrl"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 3"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-blue"></i> Planned
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Edit disciplinaryCase Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Training Needs</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onPutSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Skill Gap <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="skillGapId"
                    @change="getProgrammes"
                  >
                    <option>Select Skill Gap</option>
                    <option
                      v-for="member in skillGaps"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Program <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="need.trainingProgrammeId"
                  >
                    <option>Select Program</option>
                    <option
                      v-for="member in trainingPrograms"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.programme }}
                    </option>
                  </select>
                </div>

                <div class="submit-section">
                  <button
                    @submit.prevent="onPutSubmit"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit training needs Modal -->
        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeStatus">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Training Approve</h3>
                <p>Are you sure want to approve for this training?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeNeedStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeNeedStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
        <!-- Delete training needs Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Training Needs</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="onDeleteSubmit"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete disciplinaryCase Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { trainingService } from "@/services/trainingService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogStatus: false,
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "Skill Gap", value: "trainingProgramme.skillGap.name" },
        { text: "Program", value: "trainingProgramme.programme" },
        { text: "Status", value: "stat" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      skillGapId: 0,
      need: {},
      loading: false,
      error: "",
      trainingPrograms: [],
      skillGaps: [],
      trainingNeeds: [],
      pickPrograms: [],
      selectedPrograms: [],
      submitted: false,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue
    };
  },

  validations: {
    skillGap: { required },
    program: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  computed: {
    sortedTrainingNeeds: function() {
      function compare(a, b) {
        if (new Date(a.createdAt).getTime() < new Date(b.createdAt).getTime())
          return 1;
        if (new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime())
          return -1;
        return 0;
      }

      return this.trainingNeeds
        ? this.trainingNeeds.sort(compare)
        : this.trainingNeeds;
    }
  },
  methods: {
    getSkillGaps() {
      trainingService.getSkillGap(this.company.id).then(
        model => {
          this.skillGaps = model;
        },
        error => {
          error = error;
        }
      );
    },
    getProgrammes() {
      trainingService
        .getTrainingProgrammesBySkillGap(this.skillGapId)
        .then(r => {
          this.trainingPrograms = r;
        });
    },
    getNeeds() {
      trainingService
        .getCurrentTrainingNeedByManager(this.user.employee.id)
        .then(r => {
          this.trainingNeeds = r;
        });
    },
    openDialog() {
      this.dialog = true;
    },
    close() {
      this.clearList();
      this.dialog = false;
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeStatus() {
      this.dialogStatus = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearList() {
      this.employeeId = "";
      this.user.employee.id = "";
      this.selectedPrograms = "";
    },
    setEditNeed(model) {
      this.need = model;
      this.skillGapId = model.trainingProgramme.skillGapId;
      this.dialogEdit = true;
    },
    setApproveNeed(model) {
      this.need = model;
      this.dialogStatus = true;
    },
    setDeleteNeed(model) {
      this.need = model;
      this.dialogDelete = true;
    },
    onDeleteSubmit() {
      const id = this.need.id;
      trainingService.removeNeed(id).then(id => {
        trainingService
          .getCurrentTrainingNeedByManager(this.user.employee.id)
          .then(r => {
            this.trainingNeeds = r;
            this.closeDelete();
          });
      });
    },

    onSubmit() {
      this.submitted = true;

      this.loading = true;
      var req = {
        employeeId: this.user.employee.id,
        programs: this.selectedPrograms
      };
      trainingService.addNeed(req).then(
        id => {
          this.message = "Training Provider created successfully";
          trainingService
            .getCurrentTrainingNeedByManager(this.user.employee.id)
            .then(r => {
              this.trainingNeeds = r;
              this.close();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    changeNeedStatus(stat) {
      this.need.status = stat;
      let id = this.need.id;
      trainingService.editNeed(id, this.need).then(
        id => {
          trainingService
            .getCurrentTrainingNeedByManager(this.user.employee.id)
            .then(r => {
              this.trainingNeeds = r;
              this.closeStatus();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    onPutSubmit() {
      this.loading = true;
      let id = this.need.id;
      trainingService.editNeed(id, this.need).then(
        id => {
          this.message = "Training Need updated successfully";
          trainingService
            .getCurrentTrainingNeedByManager(this.user.employee.id)
            .then(r => {
              this.trainingNeeds = r;
              this.closeEdit();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    selectedAllFrom() {
      var selectOption = [];
      $(document)
        .find("#customleave_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select_to")
        .append(selectOption);
      this.selectedPrograms = this.trainingPrograms;
    },
    selectedFrom() {
      var selectOption = [];
      $(document)
        .find("#customleave_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select_to")
        .append(selectOption);
      this.selectedPrograms.push(this.pickPrograms[0]);
      // console.log(this.selectedEmployees)
    },
    selectedAllTo() {
      var selectOption = [];
      $(document)
        .find("#customleave_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#customleave_select")
        .append(selectOption);

      this.selectedPrograms = [];
    },
    selectedTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#customleave_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#customleave_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedPrograms = data;
        // console.log(this.selectedEmployees)
      });
    }
  },

  mounted() {
    this.getSkillGaps();
    this.getNeeds();

    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeedisciplinaryMeasures(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    $(document).on("change", "#customleave_select", function() {
      //$(this).find('option:selected')
      return false;
    });
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "trainingNeeds"
};
</script>



// WEBPACK FOOTER //
// src/components/training/teamTrainingNeeds.vue